// extracted by mini-css-extract-plugin
export default {"cashierPaymentWidget":"h9X47k","emailEdit":"L41ixA"};